//---------------nav link active-------------//

//------------------home page video slide-----------------//
document.addEventListener("DOMContentLoaded", function () {
  const splideElement = document.querySelector(".splide_one");
  if (splideElement && splideElement.querySelector(".splide__slide")) {
    new Splide(splideElement, {
      type: "loop",
      perPage: 4,
      perMove: 1,
      pagination: false,
      arrows: true,
      gap: "16px",
      breakpoints: {
        1024: {
          perPage: 3,
        },
        768: {
          perPage: 2,
          padding: "5%",
        },
        550: {
          perPage: 1,
          padding: "10%",
        },
      },
    }).mount();
  }
});

//------------------home page article slide-----------------//

document.addEventListener("DOMContentLoaded", function () {
  const splideElement = document.querySelector(".splide_two");
  if (splideElement && splideElement.querySelector(".splide__slide")) {
    new Splide(splideElement, {
      perPage: 4,
      perMove: 1,
      pagination: false,
      arrows: true,
      gap: "16px",
      breakpoints: {
        1550: {
          perPage: 3,
        },
        1300: {
          perPage: 2,
        },
        550: {
          perPage: 1,
          focus: "center",
          padding: {
            right: "5%",
          },
        },
      },
    }).mount();
  }
});

//------------------single page slide-----------------//

document.addEventListener("DOMContentLoaded", function () {
  var splideElement = document.querySelector(".splide_three");
  if (splideElement) {
    new Splide(splideElement, {
      type: "loop",
      perPage: 4,
      perMove: 1,
      pagination: false,
      arrows: true,
      gap: 10,
      breakpoints: {
        2000: {
          perPage: 2,
        },
        768: {
          perPage: 1,
          padding: "10%",
        },
      },
    }).mount();
  }
});

//------------------diaspora slide-----------------//

document.addEventListener("DOMContentLoaded", function () {
  var splideElement = document.querySelector(".splide_four");
  if (splideElement) {
    var postCount = splideElement.querySelectorAll(".splide__slide").length;
    new Splide(splideElement, {
      perPage: 4,
      perMove: 1,
      gap: 10,
      pagination: false,
      arrows: postCount > 4,
      breakpoints: {
        1300: {
          perPage: 2,
        },
        475: {
          perPage: 1,
          focus: "center",
          padding: {
            right: "5%",
          },
        },
      },
    }).mount();
  }
});


//-------------desktop nav dropdown--------------//

document
  .getElementById("menuButton")
  .addEventListener("click", function (event) {
    event.stopPropagation(); // Prevent the event from reaching the document click listener
    var menu = document.getElementById("dropdownMenu");
    if (menu.style.display === "none" || menu.style.display === "") {
      menu.style.display = "block";
    } else {
      menu.style.display = "none";
    }
  });
// Add event listener to the close button
document
  .querySelector(".hm-dropdown-close")
  .addEventListener("click", function () {
    var menu = document.getElementById("dropdownMenu");
    menu.style.display = "none";
  });

//---------- BurgerMneu / Dropdown ----------//

$(document).ready(function () {
  $(".m_button").click(function () {
    $("body").toggleClass("active");
    console.log("active");
    $(".hamBurger-menu").toggleClass("open-menu");

    // Add the following lines to prevent body scrolling
    if ($("body").hasClass("active")) {
      $("body").css("overflow", "hidden");
    } else {
      $("body").css("overflow", "");
    }
  });
});

//----------------homepage video----------------//

const videos = document.querySelectorAll("video");
const playButtons = document.querySelectorAll(".play-gif");
const videoContainers = document.querySelectorAll(".video-container");

// Function to toggle play/pause for a specific video
function togglePlay(index) {
  const video = videos[index];
  if (video.paused || video.ended) {
    video.play();
  } else {
    video.pause();
  }
}

// Add click event listeners to all play buttons
playButtons.forEach((button, index) => {
  button.addEventListener("click", (event) => {
    event.stopPropagation(); // Prevent event bubbling to the container
    togglePlay(index);
  });
});

// Add event listeners to hide/show play button when video is playing/paused
videos.forEach((video, index) => {
  video.addEventListener("playing", function () {
    playButtons[index].style.opacity = 0;
  });
  video.addEventListener("pause", function () {
    playButtons[index].style.opacity = 1;
  });
});

// Add click event listeners to all video containers
videoContainers.forEach((container, index) => {
  container.addEventListener("click", () => {
    togglePlay(index);
  });
});

// ---------------ourpage popup----------------//

document.addEventListener("DOMContentLoaded", function () {
  const memberLinks = document.querySelectorAll(".members-wrap a");
  const popups = document.querySelectorAll(".popup1");
  const overlay = document.querySelector(".overlay");
  const closeIcons = document.querySelectorAll(".close-icon");

  memberLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      const id = this.getAttribute("data-id");

      // Hide all popups
      popups.forEach((popup) => {
        popup.classList.remove("active");
      });

      // Show the selected popup
      const selectedPopup = document.getElementById("popup-" + id);
      if (selectedPopup) {
        selectedPopup.classList.add("active");
      }

      // Show the overlay
      overlay.classList.add("active");
    });
  });

  // Hide the popups and overlay when clicking on the overlay
  if (overlay != null) {
    overlay.addEventListener("click", function () {
      popups.forEach((popup) => {
        popup.classList.remove("active");
      });
      overlay.classList.remove("active");
    });
  }

  // Hide the popups and overlay when clicking on a close icon
  if (overlay != null) {
    closeIcons.forEach((icon) => {
      icon.addEventListener("click", function () {
        popups.forEach((popup) => {
          popup.classList.remove("active");
        });
        overlay.classList.remove("active");
      });
    });
  }
});

//-------------Change the search placeholder text--------//

document.addEventListener("DOMContentLoaded", function () {
  var searchFields = document.querySelectorAll(".search-field");
  searchFields.forEach(function (field) {
    field.placeholder = "Search for a keyword...";
  });
});

//----------desktop article category btn dropdown-----------//

document.addEventListener("DOMContentLoaded", function () {
  var categoryButton = document.getElementById("category-button");
  var categoryButtonText = document.getElementById("category-button-text");
  var dropdown = document.getElementById("category-dropdown");

  if (categoryButton && dropdown) {
    categoryButton.addEventListener("click", function () {
      dropdown.classList.toggle("show-dropdown");
    });

    var dropdownItems = dropdown.querySelectorAll("li");
    dropdownItems.forEach(function (item) {
      item.addEventListener("click", function () {
        categoryButtonText.textContent = item.textContent; // Update button text
        dropdown.classList.remove("show-dropdown");
      });
    });
  }
});

//------------desktop trending category btn dropdown-----------//

document.addEventListener("DOMContentLoaded", function () {
  var categoryButton = document.getElementById("category-button-two");
  var categoryButtonText = document.getElementById("category-button-two-text");
  var dropdown = document.getElementById("category-dropdown-two");

  if (categoryButton && dropdown) {
    categoryButton.addEventListener("click", function () {
      dropdown.classList.toggle("show-dropdown");
    });

    var dropdownItems = dropdown.querySelectorAll("li");
    dropdownItems.forEach(function (item) {
      item.addEventListener("click", function () {
        categoryButtonText.textContent = item.textContent; // Update button text
        dropdown.classList.remove("show-dropdown");
      });
    });
  }
});

//-----------------fetching post article category-----------------//

$(document).ready(function () {
  // Event listener for topic links
  $(".topic-link").click(function (event) {
    event.preventDefault();
    var selectedTopic = $(this).data("topic");
    var selectedTopicText = $(this).text();
    $("#category-button-text").text(selectedTopicText);

    if (selectedTopic === "all") {
      $("#splide_two").show();
      $(".article-slider-topics").html(""); // Clear any previously loaded posts
    } else {
      selectPostType(selectedTopic);
    }
  });

  // JavaScript function to make AJAX requests
  function selectPostType(selectedTopic) {
    $.ajax({
      url: siteUrl +"/wp-content/themes/india-house/inc/fetch-post.php",
      type: "GET",
      data: {
        selected_topic: selectedTopic,
      },
      success: function (response) {
        $("#splide_two").hide();
        $(".article-slider-topics").html(response);
      },
      error: function (xhr, status, error) {
        console.error("Failed to fetch posts. Status: " + status);
      },
    });
  }
});

//-----------------fetching post trending category-----------------//

$(document).ready(function () {
  // Event listener for topic links
  $(".topic-link2").click(function (event) {
    event.preventDefault();
    var selectedTopic = $(this).data("topic");
    var selectedTopicText = $(this).text();
    $("#category-button-two-text").text(selectedTopicText);

    if (selectedTopic === "all") {
      $(".trending-section-hide").show();
      $(".other-element").html(""); // Clear any previously loaded posts
    } else {
      $(".trending-section-hide").hide();
      selectPostType(selectedTopic);
    }
  });

  function selectPostType(selectedTopic) {
    $.ajax({
      url: siteUrl +"/wp-content/themes/india-house/inc/trending-post.php",
      type: "GET",
      data: {
        selected_topic: selectedTopic,
      },
      success: function (response) {
        $(".other-element").html(response);
      },
      error: function (xhr, status, error) {
        console.error("Failed to fetch trending posts. Status: " + status);
      },
    });
  }
});

//---------------- homepage progress section tab----------------//
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".progress-tabs li");
  const tabDetails = document.querySelectorAll(".tab-details");
  const splideElement = document.querySelector(".splide_five");

  if (tabs.length > 0 && tabDetails.length > 0 && splideElement) {
    // Initially display the first tab and add active class to the first tab
    tabDetails.forEach((tab, index) => {
      tab.style.display = index === 0 ? "block" : "none";
    });
    tabs[0].classList.add("tb-active");

    // Initialize Splide slider
    const splide = new Splide(splideElement, {
      perPage: 1,
      perMove: 1,
      pagination: false,
      arrows: true,
      gap: "16px",
      focus: "center",
    }).mount();

    // Handle tab click
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        const tabId = tab.getAttribute("data-tab");
        const tabContent = document.getElementById(tabId);

        if (tabContent) {
          // Remove tb-active from all tabs
          tabs.forEach((tab) => tab.classList.remove("tb-active"));

          // Add tb-active to the clicked tab
          tab.classList.add("tb-active");

          // Update Splide to show the corresponding slide
          splide.go(index);
        }
      });
    });

    // Handle Splide slide change
    splide.on("move", (newIndex) => {
      // Remove tb-active from all tabs
      tabs.forEach((tab) => tab.classList.remove("tb-active"));

      // Add tb-active to the current tab
      tabs[newIndex].classList.add("tb-active");

      // Show the corresponding tab content
      tabDetails.forEach((tab, index) => {
        tab.style.display = index === newIndex ? "block" : "none";
      });
    });
  }
});

//-----------------homepage trending videopopup----------------//

document.addEventListener("DOMContentLoaded", function () {
  var modal = document.getElementById("videoModal");
  var videoFrame = document.getElementById("videoFrame");
  var closeBtn = document.querySelector(".close");

  // Check if closeBtn exists before adding event listener
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      closeModal();
    });
  }

  var postContainers = document.querySelectorAll(".trending-item-main");

  postContainers.forEach(function (container) {
    container.addEventListener("click", function (event) {
      var videoBtn = event.target.closest(".play-gif");
      var videoUrl = container.querySelector("[data-video-url]");
      if (videoBtn && videoUrl) {
        videoFrame.src = videoUrl.getAttribute("data-video-url");
        modal.style.display = "block";
        event.preventDefault();
        event.stopPropagation();
      }
    });
  });

  window.addEventListener("click", function (event) {
    if (event.target == modal) {
      closeModal();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.keyCode === 27) {
      closeModal();
    }
  });

  function closeModal() {
    modal.style.display = "none";
    videoFrame.src = "";
  }
});

//-------------------search page field focus-------------------//

document.addEventListener("DOMContentLoaded", function () {
  var inputFields = document.querySelectorAll(".search-field");

  if (inputFields.length > 0) {
    inputFields[0].focus();
  }
});

//------------------video popup for watch video section-------------//

document.addEventListener("DOMContentLoaded", function () {
  var videoContainers = document.querySelectorAll(
    ".slide-box.video-container-div"
  );
  var playButtons = document.querySelectorAll(".play-gif");
  var popup = document.getElementById("video-popup");
  var popupVideo = document.getElementById("popup-video");
  var popupVideoTitle = document.getElementById("popup-video-title");
  var popupVideoDesc = document.getElementById("popup-video-desc");

  var closeBtn = document.querySelector(".popup .close");

  function openPopup(videoUrl, videoTitle, videoDesc) {
    popupVideo.src = videoUrl;
    popup.style.display = "block";
    if (videoTitle) popupVideoTitle.innerHTML = videoTitle;
    if (videoDesc) popupVideoDesc.innerHTML = videoDesc;
  }

  function closePopup() {
    popup.style.display = "none";
    popupVideo.src = "";
  }

  videoContainers.forEach(function (container) {
    container.addEventListener("click", function (event) {
      event.stopPropagation();
      var videoUrl = event.currentTarget
        .querySelector(".video-container")
        .getAttribute("data-video");
      var videoTitle = event.currentTarget.querySelector(
        ".video-container-title"
      ).innerHTML;
      var videoDesc = event.currentTarget.querySelector(
        ".video-container-desc"
      ).innerHTML;
      console.log(videoDesc);
      openPopup(videoUrl, videoTitle, videoDesc);
    });
  });

  playButtons.forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.stopPropagation(); // Prevent the event from bubbling up to the .video-container
      var videoContainer = this.closest(".video-container");
      var videoUrl = videoContainer.getAttribute("data-video");

      openPopup(videoUrl);
    });
  });

  closeBtn.addEventListener("click", closePopup);

  window.addEventListener("click", function (event) {
    if (event.target == popup) {
      closePopup();
    }
  });

  window.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closePopup();
    }
  });

  //subscribe form
  document
    .getElementById("subscriberForm")
    .addEventListener("submit", function (e) {
      e.preventDefault();

      const email = document.getElementById("email").value;
      const name = document.getElementById("name").value;
      const zipCode = document.getElementById("zipCode").value;

      const data = {
        email: email,
        name: name,
        zipCode: zipCode,
      };

      fetch(API_PATH + "process-data.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Success:", data);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
});

//top menu
document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = window.location.href;
  const menuItems = document.querySelectorAll(".sub-nav li a");

  menuItems.forEach((item) => {
    // Check if the current URL starts with the href of the menu item
    if (currentUrl.startsWith(item.href)) {
      item.classList.add("active"); // Add active class to the current menu item
    }
  });
});

//----------------------------subscribe popup----------------------------//
$(document).ready(function() {

  // Check if the popup has been closed before
  if (!sessionStorage.getItem('subscribePopupClosed')) {
      // Show the popup after 1min
      setTimeout(function() {
          console.log('Showing popup');
          $('#subscribePopup').fadeIn();
      }, 60000);
  }

  // Close the popup when the user clicks on <span> (x)
  $('.close-btn').click(function() {
      $('#subscribePopup').fadeOut();
      sessionStorage.setItem('subscribePopupClosed', 'true');
  });

  // Close the popup when the user clicks anywhere outside of the popup
  $(window).click(function(event) {
      if ($(event.target).is('#subscribePopup')) {
          $('#subscribePopup').fadeOut();
          sessionStorage.setItem('subscribePopupClosed', 'true');
      }
  });
});